module.exports = __webpack_public_path__ + "img/Group 1030six.6619e182.png";